import { render, staticRenderFns } from "./OurFeatures.vue?vue&type=template&id=bf3d4d00&scoped=true"
import script from "./OurFeatures.vue?vue&type=script&lang=js"
export * from "./OurFeatures.vue?vue&type=script&lang=js"
import style0 from "./OurFeatures.vue?vue&type=style&index=0&id=bf3d4d00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3d4d00",
  null
  
)

export default component.exports